// 소셜 로그인 콜백 — 백엔드가 URL 프래그먼트(#)로 토큰을 전달한다
//
// 프래그먼트를 쓰는 이유: 쿼리스트링(?)은 서버 로그·Referer 헤더에 남아 토큰이 유출될 수 있다.
// 값을 읽은 뒤에는 즉시 주소창에서 제거한다(뒤로가기·북마크로 토큰이 남지 않도록).
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@taplink/web-shared";

const ERROR_MESSAGES: Record<string, string> = {
  SOCIAL_LOGIN_FAILED: "소셜 로그인 처리 중 문제가 발생했습니다.",
  UNKNOWN_PROVIDER: "지원하지 않는 로그인 방식입니다.",
  UNSUPPORTED_AUTHENTICATION: "인증 정보를 확인할 수 없습니다.",
  REJOIN_BLOCKED: "탈퇴한 계정입니다. 재가입 제한 기간이 지난 후 이용해 주세요.",
};

export function SocialCallbackPage() {
  const navigate = useNavigate();
  const { applyToken } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false); // StrictMode 이중 실행 방지

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const accessToken = params.get("accessToken");
    const errorCode = params.get("error");

    // 토큰을 읽었으면 주소창에서 즉시 제거
    window.history.replaceState(null, "", window.location.pathname);

    if (errorCode) {
      setError(ERROR_MESSAGES[errorCode] ?? "로그인에 실패했습니다.");
      return;
    }
    if (!accessToken) {
      setError("로그인 정보를 받지 못했습니다.");
      return;
    }

    applyToken(accessToken)
      .then((me) => navigate(me.termsAgreed ? "/" : "/terms", { replace: true }))
      .catch(() => setError("로그인 처리 중 문제가 발생했습니다."));
  }, [applyToken, navigate]);

  return (
    <main className="page">
      <div className="card">
        {error ? (
          <>
            <h1>로그인 실패</h1>
            <div className="alert alert-error" role="alert">{error}</div>
            <button type="button" className="btn-primary btn-block" onClick={() => navigate("/login")}>
              로그인 화면으로
            </button>
          </>
        ) : (
          <>
            <h1>로그인 중…</h1>
            <p className="subtitle" role="status">잠시만 기다려 주세요.</p>
          </>
        )}
      </div>
    </main>
  );
}
